import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { Grid } from '@mui/material'

import { Image } from '@/api/image'
import { memberPortraitQueryOptions, useUpdateMemberPortaitMutation } from '@/api/memberQueryOptions'
import { fetchDetailPermissionsQueryOptions } from '@/api/permissionsQueryOptions'
import ImageUpload from '@/components/image/ImageUpload'
import LoadProgress from '@/components/LoadProgress'
import { setPortrait } from '@/store/auth/authSlice'
import { useDispatch } from 'react-redux'

export const Route = createFileRoute(
    '/_auth/member_/$memberUuid/images',
)({
    component: MemberImagesComponent,
})

function MemberImagesComponent() {
    const params = Route.useParams()
    const memberPortraitQuery = useSuspenseQuery(
        memberPortraitQueryOptions(params.memberUuid),
    )
    const memberPortrait = memberPortraitQuery.data

    const memberPortraitMutation = useUpdateMemberPortaitMutation(
        params.memberUuid,
    )

    const permissionsQuery = useSuspenseQuery(
        fetchDetailPermissionsQueryOptions(
            'member',
            params.memberUuid,
            ['portrait'],
        ),
    )
    const permissions = permissionsQuery.data

    const dispatch = useDispatch()

    const changePortrait = permissions && permissions.filter(p => p.detail === 'portrait' && p.permissions.some(a => a === 'write')).length > 0

    const onPortraitUpload = (image: Image) => {
        memberPortraitMutation.mutate({
            referenceUuid: params.memberUuid,
            ...image,
        } as Image)
        dispatch(setPortrait(image))
    }


    if (memberPortraitQuery.isLoading || memberPortraitQuery.isFetching) {
        return <LoadProgress />
    }
    if (permissionsQuery.isLoading || permissionsQuery.isFetching) {
        return <LoadProgress />
    }

    return (
        <form>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                    }}
                >
                    <div>
                        <Grid container spacing={1}>
                            <Grid size={12}>Portrait</Grid>
                            <Grid size={12}>
                                <img
                                    src={`data:image/jpeg;base64,${memberPortrait && memberPortrait.base64}`}
                                    alt=""
                                    width="200px"
                                />
                            </Grid>
                            <Grid size={12}>
                                {changePortrait && <ImageUpload onUpload={onPortraitUpload} />}
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </form>
    )
}
